var View = require('views/base/view');
var EF = require('ef/ef');
import { SessionStorageService } from 'services/web-storage-service';
var CourseSettingsService = require('services/course-settings-service');

var LocaleService = require('services/locale-service');

var ActionbarView = View.extend({
  template: require('./templates/actionbar'),
  autoRender: true,
  className: 'row',
  listen: {
    'page:state:completed mediator': 'completed',
    'media:status:changed mediator': 'mediaStateChanged',
    'media:play mediator': 'mediaPlay',
    'media:narration mediator': 'narrationChanged',
    'media:mute:change mediator': 'muteChange',
    'button:disabled mediator': 'disableButton',
    'button:enabled mediator': 'enableButton'
  },
  setElemId: function(event) {
    if(event) {
      this.focusedElemId = $(event.target).attr('id');
    }
  },
  initialize: function() {
    //TODO: figure out what to do with page templates that don't use some of the buttons
    this.model.set('narration', EF.enrollment.getData('narration'));
    this.model.set('mute', EF.enrollment.getData('muted') === 'on');
    this.model.set('media_status_text', LocaleService.t('mediaAccessibility.none'));
    if(CourseSettingsService.get('transcript')) {
      this.model.set('transcript', true);
    }
    this.on('addedToDOM', this.addEventDelegates);

    var queryParams = SessionStorageService.getItem('queryParams');
    if(queryParams && queryParams.next && queryParams.next === 'disabled') {
      this.model.set('nextDisabled', true);
    }

    if(!EF.module.currentActivity.currentPage.get('completed') && !EF.enrollment.get('demoMode')) {
      this.model.set('nextDisabled', true);
    }

    View.prototype.initialize.apply(this, arguments);
  },
  addEventDelegates: function() {
    // focus selected actionbar button after render
    this.render = _.wrap(this.render, function(render) {
      render();
      if(this.focusedElemId) {
        this.$('#' + this.focusedElemId).focus();
      }
    });

    this.subscribeEvent('action:unload', function() {
      if(this.model) {
        this.model.set('nextDisabled', false);
        this.render();
      }
    });

    this.delegate('click', '#play_button', function(e) {
      this.setElemId(e);
      if(this.model.get('media_status') === 'completed') {
        Chaplin.mediator.publish(`media:play:${this.model.get('mediaId')}`);
      } else {
        Chaplin.mediator.publish(`action:${this.model.get('playing') ? 'pause' : 'resume'}`);
      }
    });

    this.delegate('click', '#mute_button', function(e) {
      this.setElemId(e);
      var currentState = $(e.target).attr('data-mute-state');
      Chaplin.mediator.publish('action:' + (currentState === 'on' ? 'unmute' : 'mute'));
    });

    this.delegate('click', '#narration_toggle', function(e) {
      this.setElemId(e);
      var narration = !this.model.get('narration');
      EF.enrollment.setData('narration', narration);
      this.model.set('narration', narration);
      this.model.set('showNarration', narration && this.model.get('narrationText'));
      Chaplin.mediator.publish('media:captions:change');
      this.render();
    });

    this.delegate('click', '[data-navigate]', function(e) {
      if(createjs.WebAudioPlugin.context && createjs.WebAudioPlugin.context.state === 'suspended') {
        createjs.WebAudioPlugin.context.resume();
      }
      e.preventDefault();
      const navigateTo = $(e.target).attr('data-navigate');
      if(this.model.get('nextDisabled') && (navigateTo === 'forward')) return;
      Chaplin.mediator.publish('page:navigate', navigateTo);
    });

    this.delegate('click', '[data-close]', function(e) {
      e.preventDefault();
      Chaplin.mediator.publish('feedback:all:close');
    });
  },
  mediaPlay: function(mediaId, isBackground) {
    if(!isBackground) {
      this.model.set('mediaId', mediaId);
    }
  },
  disableButton: function(buttonId) {
    this.model.set('disable_'+buttonId, true);
  },
  enableButton: function(buttonId) {
    this.model.set('disable_' + buttonId, false);
  },
  mediaStateChanged: function(status, mediaId) {
    if(this.model.get('mediaId') === mediaId) {
      this.model.set('media_status', status);
      if(status === 'playing') {
        this.model.set('playing', true);
      } else {
        this.model.set('playing', false);
      }
      this.model.set('media_status_text', LocaleService.t('mediaAccessibility.' + this.model.get('media_status')));
      this.render();
    }
  },
  completed: function() {
    this.model.set('nextDisabled', false);
    this.render();
  },
  narrationChanged: function(narrationText) {
    this.model.set('narrationText', narrationText);
    this.model.set('showNarration', narrationText && this.model.get('narration'));
    this.render();
  },
  muteChange: function(muted) {
    EF.enrollment.setData('muted', muted);
    this.model.set('mute', muted === 'on');
    this.render();
  }
});

module.exports = ActionbarView;
